import { buildRoute } from '@direct-frontend/modules-router';

export const windowsRoute = buildRoute('/windows');

export type WindowEditParams = { windowId: string };

export const windowEditRoute = buildRoute<WindowEditParams>('/windows/:windowId');
